import { ListItemCardProps } from "@components/ListItemCardCst/types";

export const mapGroupToCard = (group: any): ListItemCardProps => {
  return {
    title: group.name || group.title || "-",
    subtitle: {
      id: group.id,
      activityType: group.description || undefined,
    },
    badges: [],
    actions: [],
  };
};
